module.exports = __webpack_public_path__ + "static/media/4.c2cb33a9.JPG";